import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { tKey } from 'ember-intl';
import { EVENTS_CATEGORIES } from 'lumen/models/event';

export const EVENTS_CATEGORIES_WITH_LABEL_AND_ICON: {
  icon: IconName;
  id: string;
  translationKey: string;
}[] = [
  {
    id: EVENTS_CATEGORIES.CONFERENCE,
    translationKey: tKey('events.category.conference'),
    icon: 'events-conference',
  },
  {
    id: EVENTS_CATEGORIES.INHOUSE,
    translationKey: tKey('events.category.inhouse'),
    icon: 'calendar-accepted',
  },
  {
    id: EVENTS_CATEGORIES.LOCAL,
    translationKey: tKey('events.category.local'),
    icon: 'calendar-accepted',
  },
  {
    id: EVENTS_CATEGORIES.MUSIC,
    translationKey: tKey('events.category.music'),
    icon: 'events-music',
  },
  {
    id: EVENTS_CATEGORIES.PERFORMING_ARTS,
    translationKey: tKey('events.category.performing_arts'),
    icon: 'events-performing-arts',
  },
  {
    id: EVENTS_CATEGORIES.SPORT,
    translationKey: tKey('events.category.sport'),
    icon: 'events-sports',
  },
];
